import { takeLatest, call, all, put, select } from 'redux-saga/effects';
import { request } from '../../xhr';
import snakeCase from 'lodash/snakeCase';
import { dropFirstTimeFlag, unsetFirstTimeFlag } from './actions';
import { hasFirstTimeFlag } from './selectors';
function* dropFlagHandler({ payload: { flag , redirectTo  }  }) {
    const isFlagSet = yield select(hasFirstTimeFlag, flag);
    if (!isFlagSet) {
        return;
    }
    yield put(unsetFirstTimeFlag(flag));
    const result = yield call(request, {
        method: 'post',
        url: '/drop_first_time_flag',
        data: {
            flag: snakeCase(flag)
        }
    }, ()=>({
            success: true
        }));
    if (result && result.success && redirectTo) {
        window.location.href = redirectTo;
    }
}
export default function* saga() {
    yield all([
        takeLatest(dropFirstTimeFlag, dropFlagHandler)
    ]);
}
